/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import kitsu from '@plugins/kitsu';
import { queryString } from '@utils/format';
let $ajax;
const berkasType = {
  default: 'berkas',
  sehat: 'berkas-sehat',
  izin: 'berkas-izin',
  mundur: 'berkas-mundur',
  bersedia: 'berkas-bersedia',
};

export const state = {
  jenis: null,
};

export const mutations = {
  SET_JENIS(state, newValue) {
    state.jenis = newValue;
  },
};

export const actions = {
  async fetch({ rootState, commit }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${
          berkasType[payload.berkas || 'default']
        }`,
    });
    commit('SET_JENIS', payload.jenis || 'kasek');
    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${
          berkasType[payload.berkas || 'default']
        }`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  async getTimVerval({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${payload.berkas ||
          'berkas'}/tim-verval`,
    });
    return await $ajax.get(`/`);
  },

  action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${
      berkasType[payload.berkas || 'default']
    }/${payload.id}/${payload.type}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState, state }, payload) {
    const jenis = (state && state.jenis) || 'kasek';
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/${
      berkasType[payload.berkas || 'default']
    }/${payload.url}?${queryString(payload.params)}`;
    return Promise.resolve(url);
  },

  cekPrasyarat({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/${payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/prasyarat/${payload.id}`;
    return http.get(url).then(({ data }) => data);
  },

  async getKinerja({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL:
        process.env.VUE_APP_API_URL +
        `/psp/i/${id}/${payload.params.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'}/berkas${payload.params.tipe ||
          ''}/kinerja`,
    });
    return await $ajax.get('/', { params: payload.params });
  },

  unduhKinerja({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/${
      payload.jenis === 'kasek' ? 'peserta' : 'pelatih-ahli'
    }/berkas/kinerja/download?${queryString(payload)}`;
    return Promise.resolve(url);
  },
};
